import styled from 'styled-components';
import { inputFullStyles } from '../../utils/forms/inputStyles';
import { theme } from '../../theme';

export const Input = styled.input<any>`
  ${inputFullStyles}

  /* Overrides browser default width - note: this breaks the native [size] attribute  */
  width: 100%;

  /* Hide number arrows/spinners */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  &[type='number'] {
    -moz-appearance: textfield;
    min-width: 8ch;
    text-align: right;
  }
`;

export const Textarea = styled.textarea<any>`
  ${inputFullStyles}

  padding-block: ${theme.sizes[2]};
`;
